
define('ldsh!modules/start/companySelector/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="pull-right">\n    ';
 if (companies.length>1) { ;
__p += '\n    <div class="dropdown">\n        <button id="products-emp-name" class="btn btn-default dropdown-toggle" type="button"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n            <span>' +
__e(selectionName) +
'</span>\n            <span class="caret"></span>\n        </button>\n        <ul id="company-drop-menu" class="dropdown-menu dropdown-menu-right">\n            <li>\n                <a class="company-selector i18n" href="javascript:void(0);">' +
((__t = (groupName)) == null ? '' : __t) +
' (' +
((__t = (groupId)) == null ? '' : __t) +
')</a>\n            </li>\n            <li role="separator" class="divider"></li>\n            <li class="dropdown-header i18n" data-i18n="PUBLIC.PRODUCTS.LBL_SUBACCOUNTS"></li>\n            ';
 _.each(companies, function(company){ ;
__p += '\n            <li>\n                <a class="company-selector" href="javascript:void(0);" data-name="' +
__e(company.name) +
'" data-id="' +
__e(company.id) +
'">\n                    ' +
__e(company.name) +
' (' +
__e(company.id) +
')\n                </a>\n            </li>\n            ';
 }, this); ;
__p += '\n        </ul>\n    </div>\n    ';
 } else { ;
__p += '\n    <div id="products-emp-name-one">\n        <span><b>' +
__e((companies && companies[0]) ? companies[0].name + ' (' + companies[0].id + ')' : groupName ) +
'</b></span>\n    </div>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

